
import { switchMap } from 'rxjs/operators';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Severities, RoleAccess } from '../../shared/shared.model';
import { WoService } from '../../work-order/work-order.service';
import { TranslateService } from '@ngx-translate/core';
import { SharedService } from '../../shared/shared.service';
import { DatePipe } from '@angular/common';
import { ConfirmationService } from 'primeng/primeng';
import { BaseComponent } from '../../shared/base.component';
import { CapitalizeFirstPipe } from '../../shared/pipes/custom-pipes.pipe';
import { FormBuilder } from '@angular/forms';
import { PartRequestEntity } from '../../work-order/work-order-models';
import { of } from 'rxjs';


@Component({
    selector: 'part-request-tab',
    templateUrl: 'part-request.html',
})

export class PartRequestComponent extends BaseComponent implements OnInit {
    @Input() rights: RoleAccess = new RoleAccess();
    @Input() isOther: boolean = false;
    @Input() isinvoice: boolean = false;
    @Input() Approvestatus: number;
    @Output() refresh = new EventEmitter();
    @Input() filterJobNumber: number[];
    @Input() AllButtonDisable: boolean;
    @Input() isPageReadOnly: boolean = false;
    @Input() BOQRights: RoleAccess = new RoleAccess();
    @Input() InhouswjobId: number;
    @Input() Isinhouse: boolean = false;
    @Input() VendorApprovalstatus?:number;
    @Input() submitButton?: boolean=false;

    woId: number;
    jobId: number;
    WoJobId: number;
    WorkOrderId: number;
    viewpartss: boolean = false;
    partRequestEntity: PartRequestEntity[] = [];
    partRequest: PartRequestEntity[] = [];
    HeaderName: string;
    //Table paginations
    public rowsperOptions: any;
    public getRows: number;
    public isPager: boolean;
    togglelist: boolean = false;
    partId: number;
    partReqStatusId: number;
    partRequestId: number;
    eventName: string;
    woWorkOrderId: number;
    stacked: boolean;
    isShowAddEditEquipments: boolean;
    isEnablePartRequestApproval: boolean = false;
    isEnableVendorBOQ: boolean = false;
    isPartRequestApprovalQueue: boolean = false;
    totalRecordCount: number;// added by rakesh
    isBOQ: boolean = false;
    inputPart: PartRequestEntity = new PartRequestEntity();
    TechId: number;
    ischildWo: boolean = false;
    SubmitButton:boolean=false;
    constructor(protected translateService: TranslateService, protected _woService: WoService,
        protected sharedService: SharedService, private route: ActivatedRoute,
        private confirmationService: ConfirmationService) {

        super(sharedService, translateService)
        //Table paginations
        this.rowsperOptions = this.sharedService.getRowsPerOptions();
        this.getRows = this.sharedService.getPanelRows();
    }
    ngOnInit() {
debugger;
        if (this.isOther == true) {debugger;
            this.route.queryParams.pipe(switchMap(params => {
                this.jobId = params["idJ"];
                this.woId = params["idW"];
                return of(0);
            })).subscribe(x => this.getPartRequest());

        }
        else {
            this.route.params.pipe(switchMap(params => {
                if (params['workOrderId'] != null) {
                    this.woId = params['workOrderId'];
                    this.jobId = params['id'];
                }
                else if (this.isinvoice == true) {
                    if (params['WoJobId'] != null) {
                        this.woId = params['WorkOrderId'];
                        this.jobId = params['WoJobId'];
                    }
                    else {
                        this.jobId = params['WoJobId'];
                        this.woId = null;
                    }
                }
                else {
                    this.woId = params['id'];
                    this.jobId = null;
                }
                return of(0);
            })).subscribe(s => this.getPartRequest());

        }
        this._woService.getCompany(super.globalInfo().CompanyId).subscribe(res => {
            this.isEnablePartRequestApproval = (res.EnablePartRequestApproval == 1);
            this.isEnableVendorBOQ = (res.EnableVendorBOQ == 1);
        });
        this._woService.linkedWo.subscribe(s => {
            this.ischildWo = s;
        });
    }


    getPartRequest() {debugger
        if(this.Isinhouse)
        {
            this.jobId=this.InhouswjobId;
        }
        this._woService.getPartRequestList(super.globalInfo().CompanyId, this.woId, this.jobId)
            .subscribe(s => {
                this.partRequestEntity = s.PartLists;
                this.partRequestEntity.map(m => {
                    m.BOQDescription = (m.IsBOQRequest == 1 ? (this.translate.instant("BOQDESCRIPTION") + "" + m.Description) : m.Description);
                });
                if (this.filterJobNumber) {
                    this.partRequestEntity.map(m => {
                        m.IsEdit = super.globalInfo().MaxRoleGroup == 2 ? false : (super.globalInfo().MaxRoleGroup == 3 || super.globalInfo().MaxRoleGroup == 5 || super.globalInfo().MaxRoleGroup == 6) ?
                            (this.filterJobNumber.indexOf(m.WoJobId) == -1) : false;
                    });
                    this.totalRecordCount = s.TotalRecord;
                }
                this.totalRecordCount = s.TotalRecord;
            });
        this.refresh.emit();
    }

    togglechange() {
        this.stacked = !this.stacked;
        this.togglelist = this.togglelist == true ? false : true
    }

    addNewPartRequest() {debugger;
        this.isShowAddEditEquipments = true;
        this.woWorkOrderId = this.woId;
        //this.customerId = this.customerId;
        this.jobId = this.jobId;        
        this.HeaderName = "Add Part Request";
        this.eventName = "add";
        this.partId = 0;
        this.partReqStatusId = 0;
        this.partRequestId = 0;
        this.isPartRequestApprovalQueue = false;
        this.isBOQ = false;
        if(this.Isinhouse)
        {
            this.jobId=this.InhouswjobId;
            this.SubmitButton=this.submitButton;
            console.log(this.SubmitButton);
        }
    }

    addNewBOQPartRequest() {
        this.woWorkOrderId = this.woId;
        this.HeaderName = "Add BOQ Part Request";
        this.eventName = "add";
        this.jobId = this.jobId;
        this.isBOQ = true;
        this.inputPart = null;
        this.partRequestId = 0;
        this.TechId = 0;
        if(this.Isinhouse)
        {
            this.jobId=this.InhouswjobId;
        }
    }

    editBOQPartRequest(part: PartRequestEntity) {
        this.woWorkOrderId = this.woId;
        this.jobId = part.WoJobId;
        this.isBOQ = true;
        this.inputPart = part;
        this.partRequestId = part.PartRequestId;
        this.HeaderName = "Edit BOQ Part Request";
        this.eventName = "edit";
    }


    editNewPartRequest(part: PartRequestEntity) {debugger;
        this.isBOQ = false;
        this.isShowAddEditEquipments = true;
        this.woWorkOrderId = this.woId;
        this.jobId = this.jobId;
        //this.customerId = this.customerId;
        this.HeaderName = "Edit Part Request";
        this.eventName = "edit";
        this.partId = part.PartId;
        this.partReqStatusId = part.PartReqStatusId;
        this.partRequestId = part.PartRequestId;
        if(this.Isinhouse)
        {
            this.jobId=this.InhouswjobId;
            this.SubmitButton=this.submitButton;
            console.log(this.SubmitButton);
        }
        // Check Part Request Approval Status If Approved or Rejected - Requested Qty is Readonly Mode..
        if (this.isEnablePartRequestApproval && (part.ApprovalStatusId == 3 || part.ApprovalStatusId == 4))
            this.isPartRequestApprovalQueue = true;
        else
            this.isPartRequestApprovalQueue = false;
    }

    closeAddEditEquipmentPopup(responsedata: any) {
        this.jobId = null;
        if (responsedata == true)
            this.isShowAddEditEquipments = false;
        else
            this.isShowAddEditEquipments = true;

        this.getPartRequest();
    }

    cancel() {

        if (this.partRequest.length > 0) {
            this.confirmationService.confirm({
                message: this.translate.instant('7257'),
                header: this.translate.instant('CANCELCONFIRM'),
                icon: 'fa fa-trash',
                accept: () => {
                    this._woService.UpdateallocatedPartRequest(super.globalInfo().CompanyId, super.globalInfo().LoginId, this.partRequest, 1)
                        .subscribe(s => {
                            if (s.Message.MessageCode == "1001" || s.Message.MessageCode == "1002") {
                                this.sharedService.notification.emit({
                                    severity: Severities[s.Message.Severity],
                                    summary: CapitalizeFirstPipe.prototype.transform(Severities[s.Message.Severity]),
                                    detail: this.translate.instant('PARTREQUESTCANCELLEDSUCCESSFULLY')
                                });

                                this.getPartRequest();
                                this.partRequest = [];
                            }
                            else {
                                this.sharedService.notification.emit({
                                    severity: Severities[s.Message.Severity],
                                    summary: CapitalizeFirstPipe.prototype.transform(Severities[s.Message.Severity]),
                                    detail: this.translate.instant(s.Message.MessageCode)
                                });
                            }

                        });
                }
            });
        }
        else {
            this.sharedService.notification.emit({
                // severity: 'error', summary: this.translate.instant('2082')
                severity: Severities[Severities.error],
                summary: CapitalizeFirstPipe.prototype.transform(Severities[Severities.error]),
                detail: this.translate.instant('2082')
            });
        }
    }

    checked(value) {

        if (value.Status) {
            this.partRequest.push(value);
        } else {
            var x = value;
            let index: number = this.partRequest.indexOf(x);
            if (index !== -1) {
                this.partRequest.splice(index, 1);
            }
        }
    }

    checkAll(event) {
        this.partRequestEntity.filter(x => (x.PartReqStatusId == 1 || x.PartReqStatusId == 2 || x.PartReqStatusId == 3 || (x.PartReqStatusId == 4 && this.isOther == true))).forEach(item => {
            if (event) {
                item.Status = true;
            } else {
                item.Status = false;
            }

        });

        this.partRequest = this.partRequestEntity.filter(x => (x.PartReqStatusId == 1 || x.PartReqStatusId == 2 || x.PartReqStatusId == 3 || (x.PartReqStatusId == 4 && this.isOther == true))).map(m => Object.assign({}, m));
        if (!event) {
            this.partRequest = [];
        }

        //console.log(this.partRequest);
    }

    viewparts(data: any) {
        this.partId = data.PartId;
        this.viewpartss = true;
    }

    closepartspreview(res: any) {
        this.viewpartss = false;
    }

    exportdata() {
        //  this.convert(this.addressList.CustomerAddresses)
    }

    refreshGrid() {
        this.getPartRequest();
    }

    closeBOQPopup(event: any) {
        this.isBOQ = false;
        this.jobId = null;
        debugger;
        if (event == true)
            this.getPartRequest();
    }
   

}